import { DownChevronIcon } from "../../../modules/Icons"
import { MobileNavProps } from "../../../types/components/academy/sidebarNav/MobileNavTypes";

const MobileNav: React.FC<MobileNavProps> = ({ showSidebar, setShowSidebar, category }) => {
  return (
    <div cy-test-id="mobile-nav" className="block bg-gray-900 md:hidden">
      <div
        onClick={() => setShowSidebar(!showSidebar)}
        className="flex items-center justify-center gap-2 p-4 font-bold uppercase cursor-pointer eurostile"
      >
        {category}
        <DownChevronIcon className={`${showSidebar ? 'rotate-180 !stroke-white' : '!stroke-white'}`} />
      </div>
    </div>
  )
}

export default MobileNav;